<template>
    <div
        class="app-container clearfix"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-row style="padding-bottom: 15px">
            <el-col :span="24">
                <h3 class="headtitle">已购模块</h3>
                <span>purchased module</span>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card>
                    <el-row>
                        <el-col :span="24">
                            <span class="right-15">所属分类:</span>
                            <el-button
                                v-for="(item, index) in lstBusinessModules"
                                :key="index"
                                size="medium"
                                :type="CurrnetMID == item.id ? 'primary' : ''"
                                @click="statusSearch(item)"
                                >{{ item.moduleName }}</el-button
                            >
                            <span class="right-15 left-15">状态:</span>
                            <el-select
                                v-model="searchModel.status"
                                placeholder="请选择状态"
                                size="medium"
                            >
                                <el-option
                                    v-for="item in statusList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                            <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-plus"
                                class="pull-right"
                                @click="addMoudle"
                                v-if="
                                    isGranted(
                                        'Pages.PurchasedModuleConfs.Create'
                                    )
                                "
                                >新增</el-button
                            >
                            <div class="inlineBlock pull-right right-20">
                                <el-input
                                    placeholder="请输入模块名称"
                                    prefix-icon="el-icon-search"
                                    v-model="searchModel.name"
                                    size="mini"
                                ></el-input>
                            </div>
                        </el-col>
                        <el-col :span="24"></el-col>
                    </el-row>

                    <el-table
                        :data="tableData"
                        size="mini"
                        style="width: 100%; margin-top: 10px"
                        border
                    >
                        <el-table-column
                            label="操作"
                            width="160"
                            v-if="
                                isGranted('Pages.PurchasedModuleConfs.Edit') ||
                                isGranted('Pages.PurchasedModuleConfs.Delete')
                            "
                        >
                            <template slot-scope="scope">
                                <el-tooltip content="编辑" placement="top">
                                    <el-button
                                        type="primary"
                                        icon="el-icon-edit"
                                        circle
                                        v-if="
                                            isGranted(
                                                'Pages.PurchasedModuleConfs.Edit'
                                            )
                                        "
                                        @click="editRow(scope.row)"
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip content="删除" placement="top">
                                    <el-button
                                        type="danger"
                                        icon="el-icon-delete"
                                        circle
                                        v-if="
                                            isGranted(
                                                'Pages.PurchasedModuleConfs.Delete'
                                            )
                                        "
                                        @click="deleteRow(scope.row.id)"
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                                <!-- <el-button type='primary' size='mini' @click='gotoStore(scope.row.id)'>门店</el-button>
                <el-button type='primary' size='mini' @click='gotoBrand(scope.row.id)'>品牌</el-button>-->
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="tenantName"
                            label="商户名称"
                        ></el-table-column>
                        <el-table-column
                            prop="name"
                            label="模块名称"
                        ></el-table-column>
                        <el-table-column label="启用时间">
                            <template slot-scope="scope">{{
                                timeFormat(scope.row.startTime)
                            }}</template>
                        </el-table-column>
                        <el-table-column label="结束时间">
                            <template slot-scope="scope">{{
                                timeFormat(scope.row.endTime)
                            }}</template>
                        </el-table-column>
                        <el-table-column label="财务软件版本">
                            <template slot-scope="scope">{{
                                getErpInfo(scope.row)
                            }}</template>
                        </el-table-column>
                        <el-table-column label="剩余(天)">
                            <template slot-scope="scope">{{
                                remainDays(
                                    scope.row.startTime,
                                    scope.row.endTime
                                )
                            }}</template>
                        </el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="scope">
                                <i
                                    :class="statusColor(scope.row)"
                                    style="margin-right: 10px"
                                ></i>
                                {{ statusFormat(scope.row) }}
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagerBar
                        ref="refPagerBar"
                        :apiURL="purchasedListApiUrl"
                        :GetData="getTableData"
                        :queryParam="searchModel"
                        :errorFunc="closeOpenloading"
                    ></pagerBar>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog
            v-el-drag-dialog
            :title="xtitle"
            :visible.sync="dialogVisible"
            width="42%"
            :before-close="handleClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-form
                label-width="110px"
                :model="purchasedModel"
                ref="refPurchasedForm"
                :rules="rules"
            >
                <el-form-item label="商户" prop="tenantId">
                    <el-select
                        v-model="purchasedModel.tenantId"
                        placeholder="请选择"
                        style="width: 100%"
                        @change="tenantChange"
                    >
                        <el-option
                            v-for="item in Tenants"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="模块" prop="moduleID">
                    <el-select
                        v-model="purchasedModel.moduleID"
                        placeholder="请选择"
                        style="width: 100%"
                        @change="moduleChange"
                    >
                        <el-option
                            v-for="item in Modules"
                            :key="item.id"
                            :label="item.moduleName"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="名称" prop="name">
                    <el-input
                        type="text"
                        v-model="purchasedModel.name"
                    ></el-input>
                </el-form-item>
                <el-form-item label="启用时间" prop="startTime">
                    <el-date-picker
                        v-model="purchasedModel.startTime"
                        style="width: 100%"
                        placeholder="选择日期"
                        @change="changeEnd"
                        :picker-options="pickerOptionsStart"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker
                        v-model="purchasedModel.endTime"
                        style="width: 100%"
                        placeholder="选择日期"
                        @change="changeStart"
                        :picker-options="pickerOptionsEnd"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="选择财务环境" prop="selectSupport">
                    <el-cascader
                        :disabled="disable"
                        :options="supportData"
                        placeholder="请选择财务系统环境"
                        style="width: 100%"
                        :props="cascaderProps"
                        v-model="purchasedModel.selectSupport"
                        @change="cascaderChange"
                    ></el-cascader>
                </el-form-item>
                <el-form-item label="最大门店数" prop="storeNum">
                    <el-input
                        type="number"
                        v-model="purchasedModel.storeNum"
                        min="0"
                        max="100"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
import pagerBar from '@/views/pager/pagerBar'
export default {
    data() {
        return {
            openloading: true,
            isShowTest: false,
            testTxt: '隐藏显示',
            searchModel: { name: '', moduleID: 0, status: '' },
            xtitle: '编辑模块',
            purchasedApiUrl: config.BASE_Middle_API + 'PurchasedModuleConfs', //已购模块配置API
            getModulesUrl:
                config.BASE_Middle_API + 'PurchasedModuleConfs/GetEnableModule',
            getParentModulesUrl:
                config.BASE_Middle_API +
                'PurchasedModuleConfs/GetEnableParentModule',

            purchasedListApiUrl:
                config.BASE_Middle_API + 'PurchasedModuleConfs/GetAll',
            dialogVisible: false, // 弹窗显示
            cascaderProps: { value: 'id', label: 'name' },
            lstBusinessModules: [],
            Modules: [], //所属类目
            Tenants: [], //商户
            CurrnetMID: 0,
            pickerOptionsStart: {},
            pickerOptionsEnd: {},
            purchasedModel: {
                id: null,
                name: '',
                startTime: moment(), //开始时间
                endTime: moment().add(1, 'years'), //结束时间
                selectSupport: [],
                ERPSystemVerID: '',
                moduleID: '',
                tenantId: '',
                storeNum: null
            },
            disable: true,
            supportData: [],
            tableData: [],
            statusList: [],
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入模块名称',
                        trigger: 'blur'
                    }
                ],
                startTime: [
                    {
                        required: true,
                        message: '请选择开始时间',
                        trigger: 'change'
                    }
                ],
                endTime: [
                    {
                        required: true,
                        message: '请选择结束时间',
                        trigger: 'change'
                    }
                ],
                moduleID: [
                    { required: true, message: '请选择模块', trigger: 'change' }
                ],

                tenantId: [
                    { required: true, message: '请选择商户', trigger: 'change' }
                ],
                selectSupport: [
                    {
                        type: 'array',
                        required: true,
                        message: '请选择财务软件',
                        trigger: 'change'
                    }
                ]
            }
        }
    },
    components: {
        pagerBar
    },
    mounted: function () {
        this.getModules()
        this.getTenants()
        this.initBusinessModules()
        this.getSupportCasData()
        this.changeStart()
        this.changeEnd()
        this.statusList.push({ id: 0, name: '全部' })
        this.statusList.push({ id: 1, name: '未启用' })
        this.statusList.push({ id: 2, name: '即将过期' })
        this.statusList.push({ id: 3, name: '过期失效' })
        this.statusList.push({ id: 4, name: '有效' })
    },
    methods: {
        tenantChange(val) {
            //根据所选商户 获取商户模块的财务软件版本
            const _this = this
            AjaxHelper.get(_this.purchasedApiUrl + '/GetTenantErp', {
                tenantID: val
            })
                .then(function (response) {
                    if (response.success) {
                        _this.purchasedModel.selectSupport =
                            response.result.selectSupport
                        if (_this.purchasedModel.selectSupport == null) {
                            _this.disable = false
                            _this.purchasedModel.selectSupport =
                                _this.supportData
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },

        moduleChange(val) {
            const _this = this
            AjaxHelper.get(_this.purchasedApiUrl + '/GetFatherModule', {
                moduleId: val,
                tenantID: _this.purchasedModel.tenantId
            })
                .then(function (response) {
                    if (response.success) {
                        if (response.result != null) {
                            _this.purchasedModel.startTime =
                                response.result.startTime
                            _this.purchasedModel.endTime =
                                response.result.endTime
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        changeStart() {
            this.pickerOptionsStart = Object.assign(
                {},
                this.pickerOptionsStart,
                {
                    disabledDate: (time) => {
                        return time.getTime() > this.purchasedModel.endTime
                    }
                }
            )
        },
        changeEnd() {
            this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
                disabledDate: (time) => {
                    return time.getTime() < this.purchasedModel.startTime
                }
            })
        },
        closeOpenloading() {
            this.openloading = false
        },
        statusSearch(item) {
            this.CurrnetMID = item.id
            this.searchModel.moduleID = item.id
            if (item.id === 0) {
                this.purchasedModel.moduleID = ''
            } else {
                this.purchasedModel.moduleID = item.id
            }
        },

        initBusinessModules() {
            const _this = this
            AjaxHelper.get(_this.getParentModulesUrl)
                .then(function (response) {
                    if (response.success) {
                        _this.lstBusinessModules = response.result
                        _this.lstBusinessModules.unshift({
                            moduleName: '全部',
                            id: 0
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        getModules() {
            const _this = this
            AjaxHelper.get(_this.getModulesUrl)
                .then(function (response) {
                    if (response.success) {
                        _this.Modules = response.result
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        getTenants() {
            const _this = this
            AjaxHelper.get(_this.purchasedApiUrl + '/GetTenants')
                .then(function (response) {
                    if (response.success) {
                        _this.Tenants = response.result
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        timeFormat(val) {
            return moment(val).format('YYYY-MM-DD')
        },
        remainDays(start, end) {
            const nowDate = moment().format('YYYY-MM-DD')
            const nowDays = moment(nowDate).diff(
                moment(start).format('YYYY-MM-DD'),
                'days'
            )
            if (nowDays < 0) {
                const daysone =
                    moment(end).diff(
                        moment(start).format('YYYY-MM-DD'),
                        'days'
                    ) + 1
                return daysone
            } else {
                const days =
                    moment(end).diff(
                        new moment().format('YYYY-MM-DD'),
                        'days'
                    ) + 1
                if (days <= 0) {
                    return '0'
                }
                return days
            }
        },
        statusFormat(item) {
            const nowDate = moment().format('YYYY-MM-DD')
            const nowDays = moment(nowDate).diff(
                moment(item.startTime).format('YYYY-MM-DD'),
                'days'
            )
            if (nowDays < 0) {
                return '未启用'
            } else {
                const days =
                    moment(item.endTime).diff(
                        new moment().format('YYYY-MM-DD'),
                        'days'
                    ) + 1 //结束时间算一天 需+1
                if (days < 30 && days > 0) {
                    return '即将到期'
                } else if (days <= 0) {
                    return '过期失效'
                } else {
                    return '有效'
                }
            }
        },
        statusColor(item) {
            const nowDate = moment().format('YYYY-MM-DD') //获取当前时间 排除时分秒 按整天
            const nowDays = moment(nowDate).diff(
                moment(item.startTime).format('YYYY-MM-DD'),
                'days'
            )
            if (nowDays < 0) {
                return 'fa fa-circle el-info'
            } else {
                const days =
                    moment(item.endTime).diff(
                        new moment().format('YYYY-MM-DD'),
                        'days'
                    ) + 1
                if (days < 30 && days > 0) {
                    return 'fa fa-circle el-warning'
                } else if (days <= 0) {
                    return 'fa fa-circle el-danger'
                } else {
                    return 'fa fa-circle el-success'
                }
            }
        },
        getErpInfo(row) {
            return (
                row.supportName + '-' + row.productName + '-' + row.versionName
            )
        },
        cascaderChange(val) {
            this.purchasedModel.ERPSystemVerID = val[2]
        },
        getTableData(d) {
            this.tableData = d
            this.openloading = false
        },
        getSupportCasData() {
            //获取财务版本信息 绑定级联选择控件
            const _this = this
            AjaxHelper.get(_this.purchasedApiUrl + '/GetTreeAllLevels', {})
                .then(function (response) {
                    if (response.success) {
                        _this.supportData = response.result
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        addMoudle() {
            this.dialogVisible = true
            this.New()
        },
        editRow(item) {
            const _this = this
            _this.xtitle = '编辑模块'
            _this.purchasedModel.id = item.id
            _this.purchasedModel.startTime = moment(item.startTime)
            _this.purchasedModel.endTime = moment(item.endTime)
            _this.purchasedModel.name = item.name
            _this.purchasedModel.ERPSystemVerID = item.versionID
            _this.purchasedModel.moduleID = item.moduleID
            _this.purchasedModel.tenantId = item.tenantID
            _this.purchasedModel.selectSupport = [
                item.supportID,
                item.productID,
                item.versionID
            ]
            _this.purchasedModel.storeNum = item.storeNum
            this.dialogVisible = true
            this.changeStart()
            this.changeEnd()
        },
        deleteRow(id) {
            //删除数据
            const _this = this
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    const confirmData = { Id: id }
                    AjaxHelper.delete(
                        _this.purchasedApiUrl + '/Delete',
                        confirmData
                    )
                        .then(function (response) {
                            if (response.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                })
                                _this.Refresh()
                            } else {
                                alert(response.Messages[0])
                            }
                        })
                        .catch(function (error) {})
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        save() {
            const _this = this
            _this.purchasedModel.ERPSystemVerID =
                _this.purchasedModel.selectSupport[2]
            const postUrl = _this.purchasedApiUrl + '/CreateOrEdit'
            const days = moment(_this.purchasedModel.endTime).diff(
                moment(_this.purchasedModel.startTime),
                'days'
            )
            if (days < 0) {
                //判断启用时间是否大于结束时间
                this.$message({
                    type: 'error',
                    message: '启用时间大于结束时间'
                })
                return false
            }
            _this.$refs['refPurchasedForm'].validate((valid) => {
                if (valid) {
                    const confirmData = {
                        id: _this.purchasedModel.id,
                        name: _this.purchasedModel.name,
                        startTime: moment(
                            _this.purchasedModel.startTime
                        ).format('YYYY-MM-DD'),
                        endTime: moment(_this.purchasedModel.endTime).format(
                            'YYYY-MM-DD'
                        ),
                        ERPSystemVerID: _this.purchasedModel.ERPSystemVerID,
                        moduleID: _this.purchasedModel.moduleID,
                        tenantId: _this.purchasedModel.tenantId,
                        storeNum: _this.purchasedModel.storeNum
                    }
                    AjaxHelper.post(postUrl, confirmData)
                        .then(function (response) {
                            if (response.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '保存成功'
                                })
                                _this.New()
                                _this.Refresh()
                                _this.dialogVisible = false
                            } else {
                                _this.$message({
                                    type: 'error',
                                    message: '保存失败'
                                })
                            }
                        })
                        .catch(function (error) {})
                }
            })
        },
        Refresh() {
            this.$refs.refPagerBar.Refresh()
        },
        close() {
            this.dialogVisible = false
            this.New()
        },

        handleClose(done) {
            done()
            this.New()
        },
        New() {
            //单击新增按钮弹出Dialog
            this.xtitle = '新增模块'
            this.operation = 'Add'
            if (this.$refs['refPurchasedForm']) {
                this.$refs['refPurchasedForm'].resetFields()
                this.purchasedModel = {
                    id: null,
                    name: '',
                    startTime: moment(), //开始时间
                    endTime: moment().add(1, 'years'), //结束时间
                    selectSupport: [],
                    ERPSystemVerID: '',
                    moduleID:
                        this.searchModel.moduleID === 0
                            ? ''
                            : this.searchModel.moduleID,
                    tenantId: '',
                    storeNum: null
                }
            }
        }
    }
}
</script>

<style scoped='scoped'>
dt,
dd {
    margin: 0;
    padding: 0;
}
.el-card {
    height: calc(100vh - 217px) !important;
}
</style>